export const companyVariablesNames = {
  onboarding: 'onboarding_completed',
  receiveSetup: 'receiveSetup_completed',
};
